import deleteicon from "../../assets/svg/Assetmanagemant/delete_forever.svg";
import Groupiconblue from "../../assets/svg/partitioncontent/blueVideoImg.svg";
import loader from "../../assets/svg/Assetmanagemant/LocateUploadLoader.gif";

const InProgressVideoBlock = ({ data, deleteFunction, permission }) => {
  return (
    <div className="block upload" key={data.name}>
      <div className="uploading">
        <svg width="100" height="80" viewBox="0 -10 40 60" />
        <img
          src={loader}
          alt="Loading..."
          style={{
            width: "40px",
            height: "40px",
            position: "absolute",
            left: "35px",
            top: "25px",
          }}
        />
      </div>
      <div className="img-block ">
        <img src={Groupiconblue} alt="" />
      </div>
      <div className="text-block">
        <label title={data.filename} className="text-label">
          {data.filename}
        </label>
      </div>
      {permission === "edit" ? (
        <div className="dropdown" style={{ zIndex: 6 }}>
          <button
            onClick={(e) => {
              // e.stopPropagation();
              deleteFunction(data.id, e);
            }}
            className="delete-poster "
          >
            <img src={deleteicon} alt="" />
          </button>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default InProgressVideoBlock;
